let authenticatedClientId = null
let selectedClientId = null

const normaliseClientId = clientId => {
  if (clientId == null || clientId === '') return null
  return String(clientId)
}

const setClientScope = ({ authenticatedClient, selectedClient }) => {
  authenticatedClientId = normaliseClientId(authenticatedClient)
  selectedClientId = normaliseClientId(selectedClient)
}

const clearClientScope = () => {
  authenticatedClientId = null
  selectedClientId = null
}

const getChildClientId = () => {
  if (authenticatedClientId == null || selectedClientId == null) return null
  return authenticatedClientId === selectedClientId ? null : selectedClientId
}

const addChildClientHeader = headers => {
  const childClientId = getChildClientId()
  if (childClientId) headers['x-child-client-id'] = childClientId
  return headers
}

export {
  addChildClientHeader,
  clearClientScope,
  getChildClientId,
  setClientScope
}
